// Work Board data — committed derived output (SYSTEM/kit-os/mirror/ingest-work.py).
// Work = goals+projects reorganized by the goal axis (P2); the module is DERIVED,
// never hand-edited (ci/work-differential.py proves it byte-for-byte in CI).
// Groups = goal chunks (from the goals module, verbatim); tasks = every non-chunk
// project row, grouped under its own goal text; needs-a-goal holds the rest.
import workData from "./workBoard.json";

export const ROWS = workData.cards;
export const WORK_META = workData.meta || {};
export const STAMP = workData.stamp || null;

export function boardClock(now = new Date()) {
  const ingested = STAMP ? new Date(STAMP.ingested_at) : null;
  if (!ingested || Number.isNaN(ingested.getTime())) {
    return { hours: null, fresh: false, dead: true, stampText: "unknown" };
  }
  const hours = Math.max(0, (now.getTime() - ingested.getTime()) / 36e5);
  const fresh = hours <= 24;
  const dead = hours > 72;
  const stampText = ingested.toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
  return { hours, fresh, dead, stampText };
}

// Group rows in display order: active chunks (goal-board order), then the dated
// task-groups (their real title sorts by the dates inside — ingest pre-sorts),
// then needs-a-goal last. The module's card order already carries this; keep it.
export const GROUP_ROWS = ROWS.filter((r) => r.kind === "group");
export const TASK_ROWS = ROWS.filter((r) => r.kind === "task");

// Tasks filed under one group slug.
export function tasksOf(groupSlug) {
  return TASK_ROWS.filter((t) => (t.payload?.goalRef || "needs-a-goal") === groupSlug);
}

// Plain-English words for a task's state (Work's own vocabulary — the states on
// this board come from the source modules: EXECUTE = being worked, TABLED = parked).
export const WORK_STATE = {
  EXECUTE: { word: "Being worked on", tone: "green" },
  TABLED: { word: "Parked for now", tone: "muted" },
  PLAN: { word: "Taking shape", tone: "amber" },
  TEST: { word: "Being verified", tone: "amber" },
  CLOSE: { word: "Wrapping up", tone: "chip" },
  INTAKE: { word: "New", tone: "muted" },
  ARCHIVED: { word: "Done", tone: "dimmed" },
  UNSORTED: { word: "Needs sorting", tone: "amber" },
};

// Groups the board splits into for reading: the active chunks first (states
// EXECUTE/PLAN/TEST/CLOSE), the finished ones folded away, dated groups next,
// and the needs-a-goal dock last.
export const ACTIVE_STATES = ["EXECUTE", "PLAN", "TEST", "CLOSE"];
export const isDoneGroup = (g) => g.state === "ARCHIVED";